import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import * as serviceWorkerRegistration from "./serviceWorkerRegistration";

import "./index.css";
import App from "./App";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <BrowserRouter basename="/tools">
    <App />
  </BrowserRouter>
);

serviceWorkerRegistration.register();

/*
Notes:
If hosted locally or on GitHub Pages:

1. Replace <BrowserRouter> to <HashRouter>
2. In package.json, set "homepage": "."

*/